import { z } from 'zod';
import { ModelFolderSchema } from './models.js';
export const FitSchema = z.enum(['good', 'tight', 'too_big', 'unknown']);
export const CatalogEntrySchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    folder: ModelFolderSchema,
    fileName: z.string(),
    sizeBytes: z.number().int(),
    needsMemoryGb: z.number(),
    requires: z.array(z.string()),
    recommended: z.boolean(),
    fit: FitSchema,
    /** null while the machine cannot be asked (offline or an old agent). */
    installed: z.boolean().nullable(),
});
export const CatalogResponseSchema = z.object({ entries: z.array(CatalogEntrySchema) });
//# sourceMappingURL=catalog.js.map